import { mapGetters } from "vuex";
import OrderApi from "../../../../services/api/orderApi";

const OrderApiService = new OrderApi();

export default {
  data() {
    return {
      reasons: [],
      notes: "",
      order: this.$store.getters.returnSlipState,
    };
  },

  methods: {
    back,
    getReturnReasons,
    getReturnSlip,
    validate,
    createReturnSlip,
    printReturnSlip,
    reasonChangeCallback,
  },

  beforeMount() {
    /*
            for create mode, order from previous screen is moved here via vuex
            if user refreshes this page upon loading, redirect him to previous page since vuex will be empty
        */
    if (!this.order && !this.$route.params.returnSlipId) {
      this.back();

      return;
    }

    this.getReturnReasons();

    if (this.$route.params.returnSlipId) {
      this.getReturnSlip();
    } else {
      // set initial return quantity to 0
      this.order.suborders.forEach((suborder) => {
        suborder.items.forEach((item) => {
          item.return_quantity = 0;
        });
      });
    }
  },

  computed: {
    ...mapGetters({
      user: "userState",
    }),
  },
};

function reasonChangeCallback(data, item_index, suborder_index) {
  this.order.suborders[suborder_index].items[item_index].reason = data;
}

function back() {
  this.$router.push({
    name: "returnDetails",
    params: this.$route.params.orderId,
  });
}

function validate(print) {
  const _self = this;

  _self.$validator.validate().then((valid) => {
    if (valid) this.createReturnSlip(print);
  });
}

function getReturnSlip() {
  OrderApiService.getReturnSlip(this.$route.params.returnSlipId)
    .then(({ data }) => {
      this.order = data;
    })
    .catch(({ error_message }) => {
      this.$swal("Attention", error_message);
    });
}

function createReturnSlip(print) {
  const _self = this;

  let request = {
    id: _self.$route.params.orderId,
    data: {
      comment: this.notes,
      order_return_items: [],
    },
  };

  _self.order.suborders.forEach(function (suborder) {
    suborder.items.forEach(function (item) {
      if (item.return_quantity > 0) {
        request.data.order_return_items.push({
          suborder_item_id: item.id,
          quantity: Number(item.return_quantity),
          reason: item.reason.value,
        });
      }
    });
  });

  if (request.data.order_return_items.length) {
    _self.$loader.$emit("trigger", true);

    OrderApiService.createReturnSlip(request)
      .then((response) => {
        if (print) {
          _self.printReturnSlip(response.data.id);
        } else {
          _self.$loader.$emit("trigger", false);
          _self.$swal("Success", "Return successfully created.").then(() => {
            _self.back();
          });
        }
      })
      .catch((error) => {
        _self.$loader.$emit("trigger", false);

        if (error.response) {
          _self.$swal("Attention", error.response.data.error_message);
        } else {
          _self.$bugsnagClient.notify(new Error(error));
        }
      });
  } else {
    _self.$swal("Attention", "Please check return quantities.");
  }
}

function printReturnSlip(id) {
  if (!id) id = this.$route.params.returnSlipId;

  const _self = this;

  _self.$loader.$emit("trigger", true);

  OrderApiService.printReturnSlip(id)
    .then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data])),
        link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", id + "_return_slip.pdf");
      document.body.appendChild(link);
      link.click();

      _self.back();
    })
    .catch((error) => {
      if (error.response) {
        _self.$swal("Attention", error.response.data.message);
      } else {
        _self.$bugsnagClient.notify(new Error(error));
      }
    })
    .finally(() => {
      _self.$loader.$emit("trigger", false);
    });
}

function getReturnReasons() {
  OrderApiService.getReturnReasons().then(({ data }) => {
    data.forEach((reason) => {
      this.reasons.push({
        name: reason.reason_value,
        value: reason.reason_name,
      });
    });
  });
}
